import React from 'react';
import PropTypes from 'prop-types';
import { PrsButton, PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';
import { ButtonsContainer } from './CancelAndSubmitControlSetStyles';

const CancelAndSubmitControlSet = ({ onCancel, allFieldsValid }) => (
  <ButtonsContainer>
    <PrsButton type="button" id="cancel" className="cancel-button" onClick={onCancel}>Cancel</PrsButton>
    <PrsDefaultButton type="submit" id="submit" className="submit-button" disabled={!allFieldsValid}>Submit</PrsDefaultButton>
  </ButtonsContainer>
);

CancelAndSubmitControlSet.propTypes = {
  onCancel: PropTypes.func.isRequired,
  allFieldsValid: PropTypes.bool.isRequired,
};

export default CancelAndSubmitControlSet;
